import React, { useEffect, useRef, useCallback } from "react";
import { useLocation } from "react-router-dom";
import PropTypes from "prop-types";
import SimpleBar from "simplebar-react";
import MetisMenu from "metismenujs";
import withRouter from "components/Common/withRouter";
import { Link } from "react-router-dom";
import { withTranslation } from "react-i18next";
import Footer from "./Footer";

const SidebarContent = props => {
  const ref = useRef();
  const activateParentDropdown = useCallback((item) => {
    item.classList.add("active");
    const parent = item.parentElement;
    const parent2El = parent.childNodes[1];

    if (parent2El && parent2El.id !== "side-menu") {
      parent2El.classList.add("mm-show");
    }

    if (parent) {
      parent.classList.add("mm-active");
      const parent2 = parent.parentElement;

      if (parent2) {
        parent2.classList.add("mm-show"); // ul tag

        const parent3 = parent2.parentElement; // li tag

        if (parent3) {
          parent3.classList.add("mm-active"); // li
          parent3.childNodes[0].classList.add("mm-active"); //a
          const parent4 = parent3.parentElement; // ul
          if (parent4) {
            parent4.classList.add("mm-show"); // ul
            const parent5 = parent4.parentElement;
            if (parent5) {
              parent5.classList.add("mm-show"); // li
              parent5.childNodes[0].classList.add("mm-active"); // a tag
            }
          }
        }
      }
      scrollElement(item);
      return false;
    }
    scrollElement(item);
    return false;
  }, []);

  const removeActivation = (items) => {
    for (var i = 0; i < items.length; ++i) {
      var item = items[i];
      const parent = items[i].parentElement;

      if (item && item.classList.contains("active")) {
        item.classList.remove("active");
      }
      if (parent) {
        const parent2El =
          parent.childNodes && parent.childNodes.lenght && parent.childNodes[1]
            ? parent.childNodes[1]
            : null;
        if (parent2El && parent2El.id !== "side-menu") {
          parent2El.classList.remove("mm-show");
        }

        parent.classList.remove("mm-active");
        const parent2 = parent.parentElement;

        if (parent2) {
          parent2.classList.remove("mm-show");

          const parent3 = parent2.parentElement;
          if (parent3) {
            parent3.classList.remove("mm-active"); // li
            parent3.childNodes[0].classList.remove("mm-active");

            const parent4 = parent3.parentElement; // ul
            if (parent4) {
              parent4.classList.remove("mm-show"); // ul
              const parent5 = parent4.parentElement;
              if (parent5) {
                parent5.classList.remove("mm-show"); // li
                parent5.childNodes[0].classList.remove("mm-active"); // a tag
              }
            }
          }
        }
      }
    }
  };

  const path = useLocation();
  const activeMenu = useCallback(() => {
    const pathName = path.pathname;
    let matchingMenuItem = null;
    const ul = document.getElementById("side-menu");
    const items = ul.getElementsByTagName("a");
    removeActivation(items);

    for (let i = 0; i < items.length; ++i) {
      if (pathName === items[i].pathname) {
        matchingMenuItem = items[i];
        break;
      }
    }
    if (matchingMenuItem) {
      activateParentDropdown(matchingMenuItem);
    }
  }, [path.pathname, activateParentDropdown]);

  useEffect(() => {
    ref.current.recalculate();
  }, []);

  useEffect(() => {
    new MetisMenu("#side-menu");
    activeMenu();
  }, []);

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
    activeMenu();
  }, [activeMenu]);

  function scrollElement(item) {
    if (item) {
      const currentPosition = item.offsetTop;
      if (currentPosition > window.innerHeight) {
        ref.current.getScrollElement().scrollTop = currentPosition - 300;
      }
    }
  }

  return (
    <React.Fragment>
    <SimpleBar className="h-100" ref={ref}>
      <div id="sidebar-menu">
        <ul className="metismenu list-unstyled" id="side-menu">
          <li>
            <Link to="/users" className="">
              <i className="bx bx-user-circle"></i>
              <span>{props.t("Users")}</span>
            </Link>
          </li>
          <li>
            <Link to="/stats" className="">
              <i className="bx bx-stats"></i>
              <span>{props.t("Stats")}</span>
            </Link>
          </li>
          <li>
            <Link to="/statsCountries" className="">
              <i className="bx bx-stats"></i>
              <span>{props.t("Stats countries")}</span>
            </Link>
          </li>
          <li>
            <Link to="/statsVoices" className="">
              <i className="bx bx-stats"></i>
              <span>{props.t("Stats voices")}</span>
            </Link>
          </li>
          <li>
            <Link to="/ratings" className="">
              <i className="bx bx-star"></i>
              <span>{props.t("Ratings")}</span>
            </Link>
          </li>
          <li>
            <Link to="/feedback" className="">
              <i className="bx bx-copy-alt"></i>
              <span>{props.t("Feedback")}</span>
            </Link>
          </li>
          <div className="separator" />
          <h4>Admin</h4>
          <li>
            <Link to="/content" className="">
              <i className="bx bx-book"></i>
              <span>{props.t("Content app")}</span>
            </Link>
          </li>
          <li>
            <Link to="/contentExtra" className="">
              <i className="bx bx-book"></i>
              <span>{props.t("Content extra")}</span>
            </Link>
          </li>
          <li>
            <Link to="/voices" className="">
              <i className="bx bx-microphone"></i>
              <span>{props.t("Voices")}</span>
            </Link>
          </li>
          <li>
            <Link to="/assistant" className="">
              <i className="bx bx-chat"></i>
              <span>{props.t("Assistant")}</span>
            </Link>
          </li>
          <li>
            <Link to="/notifications" className="">
              <i className="bx bx-bell"></i>
              <span>{props.t("Notifications")}</span>
            </Link>
          </li>
          <li>
            <Link to="/pushNotifications" className="">
              <i className="bx bx-bell"></i>
              <span>{props.t("Push notifications")}</span>
            </Link>
          </li>
          <li>
            <Link to="/emails" className="">
              <i className="bx bx-envelope"></i>
              <span>{props.t("Emails")}</span>
            </Link>
          </li>
        </ul>
        <Footer />
      </div>
    </SimpleBar>
  </React.Fragment>
  );
};

SidebarContent.propTypes = {
  location: PropTypes.object,
  t: PropTypes.any,
};

export default withRouter(withTranslation()(SidebarContent));
